<template>
    <div class="hero-content">
        <h1>
            All Your Content. <br />
            One Simple Link.
        </h1>
        <p
            class="d-none d-lg-block d-md-block text-lg"
            style="text-align: left"
        >
            Trusted by creators, brands, and businesses worldwide to connect
            their audience seamlessly.
        </p>
        <ul class="benefits">
            <li>
                <span>
                    <IconDeviceMobile
                        :size="20"
                        :stroke-width="1.5"
                        class="me-2"
                    />
                    Create your own
                    <span class="highlighted">personal page</span> with
                    allmy.online
                </span>
            </li>
            <li>
                <span>
                    <IconCash :size="20" :stroke-width="1.5" class="me-2" />
                    Earn
                    <span class="highlighted">passive income</span> with our
                    affiliate program
                </span>
            </li>
            <li>
                <span>
                    <IconPalette :size="20" :stroke-width="1.5" class="me-2" />
                    Customise, promote, and connect with your audience like
                    never before
                </span>
            </li>
        </ul>

        <div @submit.prevent="onSubmit" class="search-container">
            <input
                type="text"
                class="search-input"
                data-testid="username-input"
                :value="claimLink"
                @input="$emit('update:claimLink', $event.target.value)"
                placeholder="yourname"
                @keyup.enter="onSubmit"
            />
            <!-- Login Button with Loading Icon -->
            <button
                type="submit"
                class="claim-button amo-btn amo-btn--primary fs-5"
                :disabled="processing"
                @click="onSubmit"
                data-testid="claim-username-button"
            >
                <span
                    v-if="processing"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                ></span>
                <span v-else>Claim Username</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { IconCash, IconDeviceMobile, IconPalette } from "@tabler/icons-vue";

defineProps({
    claimLink: {
        type: String,
        default: "",
    },
    processing: {
        type: Boolean,
        default: false,
    },
    onSubmit: {
        type: Function,
        required: true,
    },
});

defineEmits(["update:claimLink"]);
</script>
